import React from 'react';
import styles from './SocialButtonsList.scss';
import { IconButton } from '../IconButton/IconButton';
import classNames from 'classnames';
import { instagramIcon } from '@justgiving/icons';
import Svg from '@justgiving/svg';
import { MODAL } from '../../context';
import { useApp } from '../../hooks';

interface InstagramShareRoundProps {
  className?: string;
  onClick?: () => void;
}

export const InstagramShareRound: React.FunctionComponent<InstagramShareRoundProps> = ({
  className,
  onClick = () => {},
}) => {
  const { showModal } = useApp();
  const linkItemClick = () => {
    showModal({ modal: MODAL.INSTAGRAM_SHARE, overwrite: true });
    onClick();
  };

  return (
    <>
      <IconButton
        className={`${styles.roundButton} ${className}`}
        onClick={() => linkItemClick()}
      >
        <div className={classNames(styles.iconWrapper)}>
          <Svg
            markup={instagramIcon}
            className={classNames(styles.icon, styles.instagram)}
          />
        </div>
        Instagram
        <div className={styles.newFeatureContainer}>
          <span>NEW</span>
        </div>
      </IconButton>
    </>
  );
};
